import * as React from 'react'
import { Expander, MoreContent } from 'DVWebNodeUI'
import { DecodedText } from '../decodedText/decodedText'
import * as st from './synopsis.module.scss'
import * as stUtility from '../utilityClasses.module.scss'
import { StringId } from '../localizer/stringId'
import { withLocalization, LocalizerProps } from '../localizer/localizer';

const DEFAULT_LINE_NUM = 3
const DEFAULT_EXPANDER_ID = 'synopsisExpander'
const LONG_SYNOPSIS_CHAR_LIMIT = 450

export interface ISynopsisProps {
  synopsis?: string
  numOfLines?: number
  expanderId?: string
}

export const SynopsisComp = ({
  synopsis,
  numOfLines = DEFAULT_LINE_NUM,
  expanderId = DEFAULT_EXPANDER_ID
}: ISynopsisProps) =>
  !synopsis ? null : (
    <div className={stUtility.fullWidth} data-automation-id={expanderId}>
      <Expander
        className={st.synopsis}
        numOfLines={numOfLines}
        uniqueId={expanderId}>
        <DecodedText string={synopsis}/>
      </Expander>
    </div>
  )

export const Synopsis = SynopsisComp


export interface IATFSynopsisProps {
  synopsis?: string
}

type AtfSynopsisContentProps = {content: string} & LocalizerProps
const AtfSynopsisContent = withLocalization(({content, getString}: AtfSynopsisContentProps) => {
  if (content.length < LONG_SYNOPSIS_CHAR_LIMIT) {
    return <p className={st.atfSynopsis}><DecodedText string={content}/></p>
  }

  const visible = content.slice(0, LONG_SYNOPSIS_CHAR_LIMIT)
  const hidden = content.slice(LONG_SYNOPSIS_CHAR_LIMIT)
  const moreString = getString(StringId.DV_DP_see_more)

  return (
    <p className={st.atfSynopsis}>
      <MoreContent
        visible={visible}
        hidden={hidden}
        key="more-content"
        moreString={moreString}
        index={1}
      />
    </p>
  )
})

export const AtfSynopsisComp = ({synopsis}: IATFSynopsisProps) =>
  !synopsis ? null : (
    <div className="avu-full-width dv-dp-node-synopsis" data-automation-id={'atf-synopsis'}>
      <AtfSynopsisContent content={synopsis} />
    </div>
  )

export const AtfSynopsis = AtfSynopsisComp

